import { render, staticRenderFns } from "./FullscreenMessage.vue?vue&type=template&id=1b7c5384&scoped=true&"
import script from "./FullscreenMessage.vue?vue&type=script&lang=ts&"
export * from "./FullscreenMessage.vue?vue&type=script&lang=ts&"
import style0 from "./FullscreenMessage.vue?vue&type=style&index=0&id=1b7c5384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c5384",
  null
  
)

export default component.exports